import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useUser } from "../../shared/context/UserContext";
import ExportPanel from "./ExportPanel";
import ImportWizard from "./ImportWizard";
import "./dataExchange.css";

export default function DataExchangePage() {
  const { userProfile, isLoading } = useUser();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab") || "import";

  useEffect(() => {
    if (!isLoading && userProfile && userProfile.role !== "ADMIN") {
      navigate("/");
    }
  }, [userProfile, isLoading, navigate]);

  const setTab = (t) => setSearchParams({ tab: t });

  if (isLoading || !userProfile || userProfile.role !== "ADMIN") return null;

  return (
    <div className="de-page">
      <div className="de-page-header">
        <h1 className="de-page-title">Data Exchange</h1>
        <p className="de-page-subtitle">Admin &middot; Import &amp; Export Tool Data</p>
      </div>
      <div className="de-tabs">
        <button className={`de-tab ${tab === "import" ? "active" : ""}`} onClick={() => setTab("import")}>
          Import
        </button>
        <button className={`de-tab ${tab === "export" ? "active" : ""}`} onClick={() => setTab("export")}>
          Export
        </button>
      </div>
      <div>
        {tab === "import" && <ImportWizard />}
        {tab === "export" && <ExportPanel />}
      </div>
    </div>
  );
}
